import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import LessonReportForm from "../../components/report/LessonReportForm";
import { toast } from "react-toastify";
import { getRequest, postRequest, putRequest, deleteRequest } from "../../apiWrapper";

const AdminEditReportPage = () => {
    const { reportId } = useParams();
    const navigate = useNavigate();
    const [reportData, setReportData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchReport = async () => {
            setLoading(true);
            try {
                console.log("edit rerpot:", reportId);
                const data = await getRequest(`lessons/${reportId}`);
                if (data && data.report) {
                    setReportData({ id: reportId, ...data.report });
                    console.log("REPORT ", data.report);
                } else {
                    toast.error("報告書が見つかりません。");
                    navigate("/reports");
                }
            } catch (error) {
                console.error("❌ 報告書の取得エラー:", error);
                toast.error("報告書の取得に失敗しました。");
                navigate("/reports");
            } finally {
                setLoading(false);
            }
        };

        fetchReport();
    }, [reportId, navigate]);

    const handleUpdate = async (updatedData) => {
        navigate("/reports");
    };

    return (
        <div className="p-0 pt-20">
            <h1 className="text-2xl font-bold mb-4">📝 報告書編集</h1>
            {loading ? (
                <p className="text-gray-500">読み込み中...</p>
            ) : (
                <LessonReportForm
                    studentid={reportData.studentid}
                    teacherid={reportData.teacherid}
                    studentName={reportData.studentName}
                    studentColor={reportData.studentColor}
                    initialData={reportData}
                    onSave={handleUpdate}
                    isAdminEditing={true}
                />
            )}
        </div>
    );
};

export default AdminEditReportPage;
